import Vue from 'vue'
import page from '@/pages/App.vue'
import vuetify from '@/plugins/vuetify'
import JsonCSV from 'vue-json-csv'
import Vue2Filters from 'vue2-filters'
import vuex from 'vuex'
import 'es6-promise/auto'
import store from '@/store/index.js'

Vue.config.productionTip = false
Vue.component("downloadCsv", JsonCSV)
Vue.use(Vue2Filters)
Vue.use(vuex)

new Vue({
  vuetify,
  store,
  render: h => h(page)
}).$mount('#app')
